import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { consumeDeferredToast } from '../utils/deferredToast';

export function useDeferredToast(enabled = true) {
    const location = useLocation();

    useEffect(() => {
        if (!enabled) return undefined;

        const pending = consumeDeferredToast();
        if (!pending?.message) return undefined;

        const options = { position: 'top-right' };
        if (pending.variant === 'error') {
            toast.error(pending.message, options);
        } else if (pending.variant === 'info') {
            toast.info(pending.message, options);
        } else {
            toast.warn(pending.message, options);
        }

        return undefined;
    }, [enabled, location.pathname]);
}
